import Vue from "vue";
import dayjs from "dayjs";

const dateFormat = (str) => {
    return new dayjs(str).format("MM/DD/YYYY");
};
Vue.prototype.$dateFormat = dateFormat;
